import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { InputGroup, MaskedInput, Panel, Text } from 'rsuite';
import { MdOutlineCheck as IconConfirm, MdOutlineEdit as IconEdit } from 'react-icons/md';

import { DisplayIcon } from './DisplayIcon';
import { DisplayIconNoBorder } from './DisplayIconNoBorder';

export const DisplayNumberInputItem = ({ register, tc, icon, onChange, borderOff }) => {
  const [value, setValue] = useState('');
  const [disabled, setDisabled] = useState(true);

  const mask = [/\d/, /\d/, /\d/, /\d/, /\d/];

  const updateValue = () => {
    if (disabled) {
      setDisabled(false);
    } else {
      setDisabled(true);
      const registerValue = parseInt(value, 10);
      if (!isNaN(registerValue)) {
        onChange(register, registerValue);
      }
    }
  };

  useEffect(() => {
    setValue(register.display);
  }, [register.display]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />
        <div className="truncate">
          <Text color={tc} className="truncate">
            {register.title}
          </Text>
          <Text color={tc} className="truncate">
            <Bold>{register.display}</Bold>
          </Text>
        </div>
        <div
          style={{
            display: 'block',
            width: '100%',
          }}
        >
          <InputGroup inside>
            <MaskedInput value={value} mask={mask} disabled={disabled} onChange={setValue} />
            <InputGroup.Button onClick={updateValue}>
              <DisplayIconNoBorder icon={disabled ? IconEdit : IconConfirm} />
            </InputGroup.Button>
          </InputGroup>
        </div>
      </Flex>
    </Panel>
  );
};
